define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MPPastureDensityDomain = void 0;
    class MPPastureDensityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MPPastureDensityDomain.None, value: "None" },
                    { key: MPPastureDensityDomain.Isolated, value: "Isolated" },
                    { key: MPPastureDensityDomain.VerySparse, value: "Very Sparse" },
                    { key: MPPastureDensityDomain.SparseOrOpen, value: "Sparse or Open" },
                    { key: MPPastureDensityDomain.MidDense, value: "Mid-Dense" },
                    { key: MPPastureDensityDomain.ClosedOrDense, value: "Closed or Dense" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MPPastureDensityDomain.None] = 0;
                this.KeyIndex[MPPastureDensityDomain.Isolated] = 1;
                this.KeyIndex[MPPastureDensityDomain.VerySparse] = 2;
                this.KeyIndex[MPPastureDensityDomain.SparseOrOpen] = 3;
                this.KeyIndex[MPPastureDensityDomain.MidDense] = 4;
                this.KeyIndex[MPPastureDensityDomain.ClosedOrDense] = 5;
                this.ValueIndex = {};
                this.ValueIndex["None"] = 0;
                this.ValueIndex["Isolated"] = 1;
                this.ValueIndex["Very Sparse"] = 2;
                this.ValueIndex["Sparse or Open"] = 3;
                this.ValueIndex["Mid-Dense"] = 4;
                this.ValueIndex["Closed or Dense"] = 5;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MPPastureDensityDomain = MPPastureDensityDomain;
    Object.defineProperty(MPPastureDensityDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MPPastureDensityDomain, "Isolated", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MPPastureDensityDomain, "VerySparse", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MPPastureDensityDomain, "SparseOrOpen", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MPPastureDensityDomain, "MidDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MPPastureDensityDomain, "ClosedOrDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MPPastureDensityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
